import { useLocation } from 'react-router-dom';
const initLinks = config => [{
  Name: 'Licence Orders',
  Url: config.LicenceOrderUrl
}, {
  Name: 'Master Orders',
  Url: config.MasterOrderUrl
}, {
  Name: 'Material Orders - Hub',
  Url: config.MaterialsOrderHubUrl
}, {
  Name: 'Material Orders - External',
  Url: config.MaterialsOrderExternalUrl
}];
export const useHeaderLinks = config => {
  const location = useLocation();
  const allHeaderMenuLinks = initLinks(config);
  const visibleHeaderLinks = allHeaderMenuLinks.filter(link => link.Url !== location.pathname);
  return {
    visibleHeaderLinks
  };
};